import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, SingleYearValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class SingleYearHandler implements IQueryConditionHandler {
  convert(qc: QueryCondition) {
    const yv = (qc.value as SingleYearValue);
    return [{
      'FilterField': qc.fieldCode,
      'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
      'Value': yv.yearValue,
      'Relation': (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And, // and undefined
      'Expresstype': ValueType.Value,
      'Lbracket': qc.Lbracket || null,
      'Rbracket': qc.Rbracket || null
    }];
  }
}
